import { DynamicQuestionnaireFields } from '@core/data-access/models/api/dynamic-questionnaire-fields.model';
import { createActionGroup, emptyProps } from '@ngrx/store';

export const BuyerQuestionnaireActions = createActionGroup({
  source: 'Buyer questionnaire',
  events: {
    'Reset reducer': emptyProps()
  }
});

export const BuyerQuestionnaireDynamicFieldsActions = createActionGroup({
  source: 'Buyer questionnaire dynamic fields',
  events: {
    'Set buyer questionnaire dynamic fields': (dynamicBuyerQuestionnaireFields: DynamicQuestionnaireFields) => ({
      dynamicBuyerQuestionnaireFields
    }),
    'Reset buyer questionnaire dynamic fields': emptyProps()
  }
});

export const BuyerQuestionnaireFormsActions = createActionGroup({
  source: 'Buyer questionnaire forms',
  events: {}
});
